const STEPS = [
  {
    title: "Ganti foto pribadi",
    body: "Buka Media → unggah foto Anda (tarik atau klik). Lalu buka Pengaturan untuk memilih 'Foto hero/profil' dan 'Foto Tentang Saya'. Foto akan langsung tampil di beranda dan halaman Tentang setelah disimpan.",
  },
  {
    title: "Menulis artikel",
    body: "Buka Tulisan → Tulis Baru. Isi judul dan isi dengan editor (heading, tebal, tautan, daftar, kutipan, gambar). Artikel tersimpan otomatis sebagai draf. Tekan 'Terbitkan' untuk menampilkannya di situs, atau 'Jadwalkan' agar terbit otomatis di waktu yang dipilih (WITA).",
  },
  {
    title: "Mengubah halaman (Beranda, Tentang, dll.)",
    body: "Buka Halaman, pilih tab yang diinginkan, sunting teksnya, lalu tekan Simpan. Perubahan langsung terlihat di situs tanpa perlu deploy ulang.",
  },
  {
    title: "Menambahkan buku & link Lynk.id",
    body: "Buka Buku & Karya → Tambah Karya. Unggah cover asli dan 3-5 visual pendukung, isi manfaat dan FAQ. Tempel URL produk Lynk.id di kolom checkout_url (harus https://...lynk.id/...). Setelah karya diterbitkan, tombol 'Beli di Lynk.id' aktif di situs.",
  },
  {
    title: "Menangani pesan konsultasi/kontak",
    body: "Setiap formulir masuk ke Konsultasi & Pesan. Ubah status Baru → Diproses → Selesai saat Anda menindaklanjuti. Anda juga menerima notifikasi email untuk pesan baru.",
  },
  {
    title: "Mengirim newsletter",
    body: "Buka Newsletter. Subscriber masuk sebagai 'menunggu' dan menjadi aktif setelah mengklik tautan konfirmasi di email mereka. Buat edisi (tulis bebas atau pilih artikel), kirim 'Kirim Uji' ke email pemilik untuk mengecek tampilan, lalu 'Kirim' untuk seluruh subscriber aktif — hanya sekali per edisi.",
  },
  {
    title: "Menyiapkan halaman Privasi & Ketentuan",
    body: "Buka Halaman → tab Privasi/Ketentuan, ganti teks contoh dengan kebijakan Anda sendiri, lalu Simpan.",
  },
  {
    title: "Cadangan & pemulihan",
    body: "Pengaturan → 'Ekspor konten (JSON)' mengunduh seluruh tulisan, karya, halaman, dan pengaturan. 'Pulihkan dari berkas' menimpa konten dengan berkas cadangan — konfirmasi ditampilkan sebelum menimpa. Ekspor subscriber (CSV) ada di menu Newsletter.",
  },
  {
    title: "Menjaga data tetap aman",
    body: "Konten, foto, subscriber, dan pesan tersimpan permanen di database — tetap utuh setelah restart atau republish. Perubahan konten via admin tidak butuh deploy ulang; hanya perubahan kode/desain yang memerlukan Publish/Re-publish platform.",
  },
];

export default function AdminGuide() {
  return (
    <div data-testid="admin-guide-page" className="max-w-2xl">
      <h1 className="font-serif text-3xl text-ink">Panduan Sehari-hari</h1>
      <p className="text-sub text-sm mt-2">Langkah bernomor untuk tugas paling sering di Admin.</p>
      <ol className="mt-8 space-y-5">
        {STEPS.map((s, i) => (
          <li key={i} className="bg-surface border border-line rounded-lg p-6 flex gap-4" data-testid={`guide-step-${i + 1}`}>
            <span className="w-9 h-9 rounded-full bg-enji/10 text-enji flex items-center justify-center font-serif text-lg shrink-0">{i + 1}</span>
            <div>
              <p className="font-semibold text-ink">{s.title}</p>
              <p className="text-sub text-[15px] leading-relaxed mt-1.5">{s.body}</p>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

